module.exports = __webpack_public_path__ + "img/bgBox_bg.9fc901a7.png";